import { default as SubtopicList } from './SubtopicListContainer';

export default SubtopicList;
